import React from "react";

import { SanityCta, SanityProduct } from "@graphql-types";
import { ButtonTheme, isSanityLink, isSanityProduct } from "@util/types";
import { Button } from ".";
import { addItemToCart, getProduct } from "@util/shopifyHelper";
import { useStore } from "@state/store";
import { toast } from "react-toastify";
import CartSuccessToast from "./cartSuccessToast";

interface Props {
  data: SanityCta;
  whiteBackground?: boolean;
  padding?: string;
}

function Cta({ data, whiteBackground, padding }: Props) {
  if (data == null) {
    return null;
  }

  const { checkout } = useStore();

  const { ctaStyle, ctaType } = data;

  if (ctaType == null || ctaStyle == null || ctaType[0] == null) {
    return null;
  }

  const handleCartButtonClick = (item: SanityProduct) => {
    if (checkout == null || checkout.id == null) {
      toast.error("There was a problem adding this item to your Cart.");
      return null;
    }
    getProduct(item)
      .then(itemData => {
        if (!itemData || itemData.length === 0) {
          toast.error("Product not found.");
          return;
        }

        const product = itemData[0];
        if (!product.variants || !product.variants.edges || product.variants.edges.length === 0) {
          toast.error("Product variant not found.");
          return;
        }

        const variantId = product.variants.edges[0].node.id;

        addItemToCart(checkout.id, variantId, 1);
        toast.success(CartSuccessToast);
      })
      .catch(error => {
        console.error("Error adding item to cart:", error);
        toast.error("There was a problem adding this item to your Cart.");
      });
    return;
  };

  if (isSanityLink(ctaType[0]) && ctaType[0].url) {
    return (
      <Button
        theme={whiteBackground ? (`${ctaStyle}` as ButtonTheme) : (`${ctaStyle}White` as ButtonTheme)}
        text={ctaType[0].linktext as string}
        linkTo={ctaType[0].url}
        padding={padding}
      />
    );
  }

  if (isSanityProduct(ctaType[0])) {
    return (
      <Button
        theme={whiteBackground ? (`${ctaStyle}` as ButtonTheme) : (`${ctaStyle}White` as ButtonTheme)}
        text="Add to Cart"
        onClick={() => handleCartButtonClick(ctaType[0] as SanityProduct)}
        padding={padding}
      />
    );
  }
  return null;
}

export default Cta;
